import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary/AppErrorBoundary";
import { installVitePreloadRecovery } from "./util/vitePreloadRecovery";

import { BrowserRouter } from "react-router-dom";
import AppProviders from "./context/AppProviders";

installVitePreloadRecovery();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppErrorBoundary>
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </AppErrorBoundary>
);
// Polyfill for libraries that expect global regeneratorRuntime
import 'regenerator-runtime/runtime';
